import { render, staticRenderFns } from "./ProductsVertical.vue?vue&type=template&id=2d36a03e&scoped=true&"
import script from "./ProductsVertical.vue?vue&type=script&lang=js&"
export * from "./ProductsVertical.vue?vue&type=script&lang=js&"
import style0 from "./ProductsVertical.vue?vue&type=style&index=0&id=2d36a03e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d36a03e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
